var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSensorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.09091C0 0.488417 0.488417 0 1.09091 0H22.9091C23.5116 0 24 0.488417 24 1.09091V22.9091C24 23.5116 23.5116 24 22.9091 24H1.09091C0.488417 24 0 23.5116 0 22.9091V1.09091Z",
    fill: "#74797D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.90909C2 2.40701 2.40701 2 2.90909 2H21.0909C21.593 2 22 2.40701 22 2.90909V21.0909C22 21.593 21.593 22 21.0909 22H2.90909C2.40701 22 2 21.593 2 21.0909V2.90909Z",
    fill: "#CDD0D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorIcon);
export default __webpack_public_path__ + "static/media/sensor-icon.b9b3a9bfbd9eee6da98ff82cb25a83b1.svg";
export { ForwardRef as ReactComponent };